import { Component, Input } from '@angular/core';
import { COSMIC_THEME, NbDialogRef, NbDialogService, NbToastrService, NbGlobalPhysicalPosition, NbIconConfig  } from '@nebular/theme';

import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { GameService, MissionService } from '../../_services/index';

import { Game, Mission } from '../../classes/index';
import { trigger, transition, animate, style } from '@angular/animations';

import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import  { diffChars }  from './character';

@Component({
    selector: 'cd-template-update-modal',
    templateUrl: 'template-update-modal.component.html',
    styleUrls: ['template-update-modal.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 })),
            ])
        ])
    ],
    standalone: false
})
export class TemplateUpdateModalComponent {

  @Input() templateId;
  @Input() missions: Mission[] = [];
  @Input() attributes: string[] = []; //['name','description', 'successMessage'...] {en:'test', fr:'test'}
  @Input() listAttributes: [] = []; //['riddleAnswers','clues', 'forkSelections', 'failMessageList'...] [{labels: {en:'test', fr:'test'}}]
  @Input() languages: string[] = []; //['fr','en','nl']
  @Input() characters: [] = [];
  
  games;
  gameVisibly = [];
  nbrOfChanges
  changesexist = false
  contentLoaded = false
  _languages;
  options = [];
  changes =[]
  added = []
  positions = NbGlobalPhysicalPosition;
  attributesChanges = []
  checkedAtt = {}

  constructor(protected ref: NbDialogRef<TemplateUpdateModalComponent>,
    private router: Router,
    private gameService: GameService,
    private dialogService: NbDialogService,
    private missionService: MissionService,
    private toastrService: NbToastrService) {}

  ngOnInit(): void {
    if(this.missions[0].customRiddle){
      for( var i = 0; i < this.attributes.length; i++){
        if (this.attributes[i] === "riddleText" || this.attributes[i] === "riddleAnswers" || this.attributes[i] === "riddleAnswer" || this.attributes[i] === "riddleClues"){
          this.attributes.splice(i, 1);
          i--;
        }
      }
    }
    if(this.templateId) this.getGameModifsFromTemplate()
    this._languages = [...this.languages]
    if(this._languages){
      for (let i = 0; i < this._languages.length; i++) {
        this.options.push({checked: true , language: this._languages[i]});
      }
    }
  }

  loadDetailParam(param) {
    this.checkedAtt[param] = !this.checkedAtt[param];
  }
  
  getGameModifsFromTemplate(){
    console.log('Load template:'+this.templateId);
    this.gameService.listTemplateGames(this.templateId)
    .pipe(take(1))
    .subscribe(async games => {
      console.log('Found games:'+games.length);
      let missions = await this.missionService.listMissionsById(this.missions[0].id).pipe(take(1)).toPromise();
      console.log('Found missions:'+missions.length);
      for(let game of games){
        game.missions = missions.filter(mission => mission.gameId == game.id);
      }
      await this.missionService.listGameModifsFromTemplate([this.missions[0]], games, this.attributes, this.languages);
      this.games = games;
      for (let i = 0; i < this.games.length; i++) {
        this.toggleShowDetailGame(i)
        this.getAllAttributes(this.games[i],i)
        this.added[i] = this.getNbrChangesOrAdd(this.games[i],'add')
        this.changes[i] = this.getNbrChangesOrAdd(this.games[i],'changes');
      }
      this.nbrOfChanges = this.getAllGamesNbrChanges();
      console.log('nbrOfChanges:'+this.nbrOfChanges);
      this.attributesChanges.sort();
      for (let i = 0; i < this.attributesChanges.length; i++) {
        this.checkedAtt[this.attributesChanges[i]] = true
      }
      this.contentLoaded = true
    });
  }

  getAllAttributes(game,i){
    if (game.missions[0]){
      const changes = game.missions[0].changes;
      for (let l = 0; l < changes.length; l++) {
        const change = changes[l];
        let attribute = this.missions[0][change.fieldName]
        for (const lang in attribute) {
          if(attribute[lang]) {
            if(!this.attributesChanges.includes(change.fieldName)) this.attributesChanges.push(change.fieldName)
          }
        }
      }
    }
  }

  deleteLang(lang){
    for( var i = 0; i < this._languages.length; i++){ 
      if ( this._languages[i] === lang) {
        this._languages.splice(i, 1);
      }
    }
  }

  ngAfterViewChecked(){
    const added = document.querySelectorAll<HTMLElement>('.added') 
    added.forEach(function(item) {
      item.style.color = '#1dc864',
      item.style.fontSize = '16px';
    });
    const removed = document.querySelectorAll<HTMLElement>('.removed')
    removed.forEach(function(item) {
      item.style.color = 'red';
      item.style.fontSize = '16px';
    }); 
  }

  removeTags(str) {
    if ((str===null) || (str===''))
        return false;
    else
        str = str.toString();
    
    return str.replace( /(<([^>]+)>)/ig, '');
  }

  getDiffAttributes(from, to, param){
    let toAtt = this.removeTags(to)
    if(from && to){
    let fromAtt = this.removeTags(from)
      let diff = diffChars(fromAtt, toAtt , {})
      if( diff.length > 1 ){
        return this.setNewColoredAttribut(diff, param)
      } else return to
    } else if (!from && to){
      return '<span class="added">'+toAtt + '</span>'
    } else return to
  }

  setNewColoredAttribut(diff, param){
    let att = ''
    for (let i = 0; i < diff.length; i++) {
      const element = diff[i];
      if(!element.removed && !element.added){
        att += element.value 
      }
      if(param === 'to'){
        if(!element.removed && element.added){
          att += '<span class="added">'+ element.value + '</span>'
        }
      }else{
        if(!element.removed && element.added){
          att += '<span class="removed">'+ element.value + '</span>'
        }
      }
    }
    return att
  }

  onChange(lang, index){
    this.options[index].checked = !this.options[index].checked 
    if(this._languages.includes(lang.language)){
      this.deleteLang(lang.language)
    } else{ this._languages.push(lang.language)}
  }


  setCustomRiddleMission(){
    this.missionService.updateMission(this.missions[0].id, {customRiddle:true})
    .then(res => {
      console.log('mission updated to costume mission');
    });
  }
  unUpdate(index){
    this.games.splice(index, 1);
  }

  toggleShowDetailGame(index) {
    this.gameVisibly[index] = this.gameVisibly[index]? !this.gameVisibly[index] : true;
  }

  getNbrChangesOrAdd(game,type){
    let changed = 0, added = 0
    if(game.missions){
      for(let mission of game.missions){
        for(let change of mission.changes){
          for(let lang of change.languages){
            this.changesexist = true
            // riddleClues - riddleText - riddleAnswer - riddleAnswers 
            if(this.attributes.includes(change.fieldName)){
              if(!mission.customRiddle) {
                if(change.fieldName == 'riddleClues' || change.fieldName == 'riddleAnswers'){
                  for (let index = 0; index < mission[change.fieldName].length; index++) {
                    // forkSelections labels
                    if(this.missions[0][change.fieldName][index]){
                      if(mission[change.fieldName][index].labels[lang] && this.missions[0][change.fieldName][index].labels[lang] && mission[change.fieldName][index].labels[lang] !== this.missions[0][change.fieldName][index].labels[lang]) changed++
                      if(!mission[change.fieldName][index].labels[lang] && this.missions[0][change.fieldName][index].labels[lang]) added++
                    }
                  }
                }
                if(change.fieldName == 'riddleText' || change.fieldName == 'riddleAnswer') {
                  if(mission[change.fieldName][lang] && this.missions[0][change.fieldName][lang] && mission[change.fieldName][lang] !== this.missions[0][change.fieldName][lang]) changed ++
                  if(!mission[change.fieldName][lang] && this.missions[0][change.fieldName][lang]) added ++
                }
                
              }

              if(change.fieldName === 'forkSelections'){
                for (let index = 0; index < mission[change.fieldName].length; index++) {
                  // forkSelections labels
                  if(this.missions[0][change.fieldName][index]){
                    if(mission[change.fieldName][index].labels[lang] && this.missions[0][change.fieldName][index].labels[lang] && mission[change.fieldName][index].labels[lang] !== this.missions[0][change.fieldName][index].labels[lang]) changed++
                    if(!mission[change.fieldName][index].labels[lang] && this.missions[0][change.fieldName][index].labels[lang]) added++

                    // forkSelections selectedTxt
                    if(mission[change.fieldName][index].selectedTxt[lang] && this.missions[0][change.fieldName][index].selectedTxt[lang] && mission[change.fieldName][index].selectedTxt[lang] !== this.missions[0][change.fieldName][index].selectedTxt[lang]) changed++
                    if(!mission[change.fieldName][index].selectedTxt[lang] && this.missions[0][change.fieldName][index].selectedTxt[lang]) added++

                    // forkSelections unselectedTxt
                    if(mission[change.fieldName][index].unselectedTxt[lang] && this.missions[0][change.fieldName][index].unselectedTxt[lang] && mission[change.fieldName][index].unselectedTxt[lang] !== this.missions[0][change.fieldName][index].unselectedTxt[lang]) changed++
                    if(!mission[change.fieldName][index].unselectedTxt[lang] && this.missions[0][change.fieldName][index].unselectedTxt[lang]) added++
                  }
                }
              } else {
                if(mission[change.fieldName].blocks || this.missions[0][change.fieldName].blocks){
                  changed++;
                }
                else{
                  if(mission[change.fieldName][lang] && this.missions[0][change.fieldName][lang] && mission[change.fieldName][lang] !== this.missions[0][change.fieldName][lang]) changed ++
                  if(!mission[change.fieldName][lang] && this.missions[0][change.fieldName][lang]) added ++
                }
              }
            }
          }
        }
      }
    }
    if(type === 'add') return added;
    else return changed;
  }

  getAllGamesNbrChanges(){
    let changes = 0;
    for(let i = 0; i < this.changes.length; i++) {
      changes += (this.changes[i]+ this.added[i])
    }
    return changes;
  }

  isLanguageActiveInGame(game, lang){
    return game.workingLanguages.indexOf(lang)>=0;
  }
  

  isLanguagesActiveInGame(game){
    let langsActiveInGame = true
    for (let i = 0; i < this.languages.length; i++) {
      const element = this.languages[i];
      langsActiveInGame = (game.workingLanguages.indexOf(this.languages[i])>=0 && langsActiveInGame)
    }
    return langsActiveInGame
  }
  
  openCityInNewWindow(gameId,missionId) {
    // Converts the route into a string that can be used 
    // with the window.open() function
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/pages/game/'+gameId+'/overview/'+missionId])
    );
    window.open(url, '_blank');
  }
  async activateLanguage(game, lang){
    if(game.workingLanguages.indexOf(lang)<0){
      game.workingLanguages.push(lang);
      await this.gameService.updateGame(game.id, {workingLanguages:game.workingLanguages});
      this.gameService.listGames()
    }
  }

  hasGameChanges(game){
    //TODO:handle game having missing missions
    if(game.missions){
      if(game.missions.length==0){
        //mission doesn't exist in game
        return true;
      }
      //console.log('game.missions.length:'+game.missions.length);
      for(let mission of game.missions){
        //console.log('this.hasMissionChanges(mission):'+this.hasMissionChanges(mission));
        if(this.hasMissionChanges(mission)){
          return true;
        }
      }
    }
    return false;
  }

  hasMissionChanges(mission){
    //console.log('hasMissionChanges:'+mission.changes.length)
    return mission.changes.length>0;
  }

  getMission(id){
    for(let mission of this.missions){
      if(mission.id == id){
        return mission;
      }
    }
    return null;
  }

  getGameMission(game, mission){
    //console.log('getGameMission:'+game+'/'+mission);
    if(game && game.missions){
      for(let gameMission of game.missions){
        if(gameMission.id == mission.id){
          return gameMission;
        }
      }
    }
    return null;
  }

  changeValidated = false;
  async applyChanges(game){
    try {
      await this.missionService.applyChanges(this.missions[0], game ? [game] : this.games, this.missions[0].id);
      this.changeValidated = true
      if(game){
        //reload and compare current mission
        this.missionService.getMission(`games/${game.id}/missions`,this.missions[0].id)
        .pipe(take(1))
        .subscribe(mission => {
          game.missions = [mission];
          this.missionService.listGameModifsFromTemplate(this.missions, [game], this.attributes, this.languages);
          this.showToast('Success', 'success', `Update attribute mission From Template`, 'done-all-outline')
        });
      }
    } catch (error) {
      console.log('Update attribute failed',error);
      this.showToast('Error', 'danger', `Update attribute failed`, 'close-outline')
    }
  }

  applyAllChanges(game){
    for( var i = 0; i < this.games.length; i++){
      if(this.games[i].missions[0]){
        for (let l = 0; l < this.games[i].missions[0].changes.length; l++) {
          if(!this.checkedAtt[this.games[i].missions[0].changes[l].fieldName]) {
		        for(let data in this.games[i].missions[0].updateData){
              let att = data.split('.')
              if(att[0] == this.games[i].missions[0].changes[l].fieldName) delete this.games[i].missions[0].updateData[data];
            }
          }
        }
      }
    }
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want apply all changes?`
      }, closeOnBackdropClick: false
    }).onClose.subscribe(async res => {
      if(res){
        await this.applyChanges(game)
        if(this.changeValidated){
          this.getGameModifsFromTemplate()
          let count=0
		      for(let game of this.games){
            for(let mission of game.missions){
              if(mission.changes.length>0){
                count++
              }
            }
          }
          this.showToast('Success', 'success', `Update missions From Template`, 'done-all-outline')
          this.ok()
        }
      }
    });
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  cancel() {
    this.ref.close();
  }

  ok() {
    this.ref.close(true);
  }
}
